// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"691711a2","261":"46376592","427":"840ffba1","462":"cbb7390a","624":"a7794b93","712":"29938421","791":"15cf8b59","793":"d9697461","831":"452bc75c","958":"d4633e3b"}[chunkId] + ".chunk.js";
};